import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { GroupKeyDto } from '@models/clash/group-key-dto';
import { InscricaoEtapaDto } from '@models/embate/clash-dto';
import { IResponseDto, ResponseDto } from '@models/exceptions/response-dto';
import { IPage } from '@models/pagination/page';
import { IPageable } from '@models/pagination/pageable';
import { FormBase } from '@models/portal/users/form-base';
import { extractResponse } from '@shared/rxjs/custom-rxjs-operators';
import { catchError, EMPTY, Observable, tap } from 'rxjs';
import { toParams } from 'src/app/core/utilities/utility-functions';
import { BaseService } from '../base-service';

@Injectable({
  providedIn: 'root',
})
export class GroupKeyService extends BaseService {
  url = this.envUrl + '/v1/inscricao-chave';
  urlEtapa = this.envUrl+ '/v1/inscricoes-etapa'
  urlChave = this.envUrl + '/v1/chaves-embate';

  vincularManual(
    form: InscricaoChaveForm,
  ): Observable<ResponseDto<InscricaoChaveDto>> {
    this.loadingService.activate();
    return this.http
      .post<
        ResponseDto<InscricaoChaveDto>
      >(`${this.url}/inscricao-cabeca-chave-manual`, form)
      .pipe(
        catchError((err) => {
          this.loadingService.deactivate();
          this.messageErrorResolver.resolveMessage(err);
          return EMPTY;
        }),
        tap(() => {
          this.loadingService.deactivate();
        }),
      );
  }
  vincularSorteioTodosParticipantesDisponiveis(
    petNrId: number,
  ): Observable<ResponseDto<InscricaoChaveDto[]>> {
    return this.http.post<ResponseDto<InscricaoChaveDto[]>>(
      `${this.url}/${petNrId}/inscricao-chave-sorteio-participantes-disponiveis`,
      {},
    );
  }



  vincularSorteioGeral(
    petNrId: number,
    cheNrId: number,
  ): Observable<ResponseDto<InscricaoChaveDto>> {
    return this.http.post<ResponseDto<InscricaoChaveDto>>(
      `${this.url}/${petNrId}/inscricao-chave-sorteio-geral/${cheNrId}`,
      {},
    );
  }

  vincularSorteioNaoCabecaChave(
    petNrId: number,
  ): Observable<ResponseDto<InscricaoChaveDto>> {
    return this.http.post<ResponseDto<InscricaoChaveDto>>(
      `${this.url}/${petNrId}/inscricao-chave-sorteio-nao-cabeca-chave`,
      {},
    );
  }

  //MOVER PARA CLASH SERVICE
  searchKeyById(cheNrId: number): Observable<ResponseDto<GroupKeyDto>> {
    return this.http
      .get<ResponseDto<GroupKeyDto>>(`${this.urlChave}/${cheNrId}`)
      .pipe(
        catchError((err) => {
          this.loadingService.deactivate();
          this.messageErrorResolver.resolveMessage(err);
          return EMPTY;
        }),
        tap(() => this.loadingService.deactivate()),
      );
  }

  listarInscricoesEtapa(
    filtro: Partial<IFiltroInscricaoEtapa>,
    pageable?: IPageable,
  ): Observable<IPage<InscricaoEtapaDto>> {
    let params = toParams({
      filtro: filtro,
      pageable: pageable,
    });
    return this.http
      .get<
        IResponseDto<IPage<InscricaoEtapaDto>>
      >(`${this.url}/inscricoes-disponiveis`, { params })
      .pipe(extractResponse());
  }

  listarInscricoesCompletas(
    petNrId: number,
    pageable?: IPageable,
     estTxDescricao?:string,
  ): Observable<IPage<InscricaoEtapaCompletaDto>> {
    let params = toParams({
      pageable: pageable,
      estTxDescricao
    });
    return this.http
      .get<
        IResponseDto<IPage<InscricaoEtapaCompletaDto>>
      >(`${this.urlEtapa}/inscricoes-completas/${petNrId}`, { params })
      .pipe(extractResponse());
  }

  deletarInscricaoChave(
    cheNrId: number,
    ineNrId: number,
  ): Observable<InscricaoChaveDto> {
    return this.http
      .delete<
        IResponseDto<InscricaoChaveDto>
      >(`${this.url}/${cheNrId}/deletar-chave/${ineNrId}`)
      .pipe(extractResponse());
  }


    resetarSorteio(
    petNrId: number,
  ): Observable<InscricaoChaveDto> {
    return this.http
      .delete<
        IResponseDto<InscricaoChaveDto>
      >(`${this.url}/resetar-sorteio/${petNrId}`)
      .pipe(extractResponse());
  }

  verificarTodosCabecasDeChaveSelecionados(
    petNrId: number
  ): Observable<IResponseDto<boolean>> {
    return this.http
      .get<
        IResponseDto<boolean>
      >(`${this.url}/verificar-quantidade-cabecas-chave/${petNrId}`);
  }

  fazerTroca(petNrId:number):Observable<InscricaoChaveDto>{
    return this.http.put<IResponseDto<InscricaoChaveDto>>(`${this.url}/${petNrId}/realizar-troca`,{}).pipe(extractResponse());
  }

}

export interface InscricaoChaveDto {
  ichNrId: number;
  inscricaoEtapaDto: InscricaoEtapaDto;
  cheNrId: number;
  fedNrId: number;
  ineBlCabecaChave: boolean;
  ichBlSede: boolean;
  fedTxSigla: string;
  estTxNome: string;
  estTxSigla: string;
  needsSedeSwap: boolean,
}
export interface InscricaoChaveForm extends FormBase {
  ineNrId?: number;
  cheNrId: number;
  ichNrIdCabecaChaveAtual?: number;
  fedNrId?: number;
  estNrId?: number;
  ichBlSede?: boolean;
}
export interface IFiltroInscricaoEtapa {
  ineNrId: number;
  incBlCabecaChave: boolean;
  petNrId: number;
  incTxResumo: string;
}
export interface InscricaoEtapaCompletaDto {
  ineNrId: number;
  incNrId: number;
  petNrId: number;
  ineBlCabecaChave: boolean;
  ineBlSorteado: boolean;
  ichNrId: number;
  cheNrId: number;
  incTxResumo: string;
  fedNrId: number;
  fedTxNome: string;
  fedTxSigla: string;
  estTxDescricao: string;
  estTxSigla: string;
  estNrId: number;
  ichBlSede: boolean;
}
